var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0295 10.1499L17.5814 9.43652C17.7691 9.36143 17.9192 9.21125 17.9192 8.98597C17.9192 8.7607 17.7691 8.61051 17.5814 8.53542L15.0295 7.82205C12.6653 7.14623 10.8639 5.34403 10.1884 3.01619L9.47536 0.463073C9.36278 0.0500693 8.68727 0.0500693 8.57469 0.463073L7.86165 3.01619C7.18615 5.38157 5.3848 7.18377 3.02052 7.82205L0.468612 8.53542C0.280972 8.61051 0.130859 8.7607 0.130859 8.98597C0.130859 9.21125 0.280972 9.36143 0.468612 9.43652L3.02052 10.1499C5.3848 10.8257 7.18615 12.6279 7.86165 14.9558L8.57469 17.5089C8.64974 17.6966 8.79986 17.8468 9.02502 17.8468C9.25019 17.8468 9.40031 17.6966 9.47536 17.5089L10.1884 14.9558C10.8639 12.5904 12.6653 10.7882 15.0295 10.1499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.4375d9c26945b67de6da44fc5af68fce.svg";
export { ForwardRef as ReactComponent };